import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AccesInterzisComponent } from './shared/acces-interzis/acces-interzis.component';
import { LayoutComponent } from './layout/layout/layout.component';
import { TokenGuard } from './guards/token.guard';
import { PermissionsGuard } from './guards/permissions.guard';
import { SettingsComponent } from './components/settings/settings.component';
import { SlugPageComponent } from './components/slugPage/slug-page.component';
import { TokenComponent } from './components/token/token.component';
import { AdminSetariComponent } from './platform/nomenclatoare/admin-setari/admin-setari.component';
import { CerereSabloaneComponent } from './components/sabloane/cerere-sabloane.component';
import { ProgramariComponent } from './components/programari/programari.component';
import { PlatiComponent } from './components/plati/plati.component';
import { CereriComponent } from './components/cereri/cereri.component';
import { ProgramariViewComponent } from './components/programari-view/programari-view.component';
import { SidenavGuard } from './guards/sidenav.guard';
import { PublicatiiCasatoriiComponent } from './components/publicatii-casatorii/publicatii-casatorii.component';

const routes: Routes = [
    {
        path: '',
        redirectTo: 'cereri',
        pathMatch: 'full',
    },
    {
        path: 'access-denied',
        component: AccesInterzisComponent,
    },
    {
        path: '',
        component: LayoutComponent,
        canActivate: [TokenGuard, PermissionsGuard, SidenavGuard],
        children: [
            {
                path: 'cereri',
                component: CereriComponent,
            },
            {
                path: 'plati',
                component: PlatiComponent,
            },
            {
                path: 'sabloane',
                component: CerereSabloaneComponent,
            },
            {
                path: 'programari',
                component: ProgramariComponent,
            },
            {
                path: 'settings',
                component: SettingsComponent,
            },
            {
                path: 'admin-settings',
                component: AdminSetariComponent,
            },
            {
                path: 'programari-view',
                component: ProgramariViewComponent,
            },
            {
                path: 'publicatii-casatorii',
                component: PublicatiiCasatoriiComponent,
            },
            { path: ':slug', component: SlugPageComponent },
        ],
    },
    {
        path: 'token/:token',
        component: TokenComponent,
    },
    {
        path: '**',
        redirectTo: 'cereri',
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            scrollPositionRestoration: 'enabled',
            anchorScrolling: 'enabled',
            useHash: true,
        }),
    ],
    exports: [RouterModule]
})
export class AppRoutingModule { }
